export const SENSOR_MODELS_FETCH_STARTED = 'SENSOR_MODELS_FETCH_STARTED';
export const SENSOR_MODELS_FETCH_COMPLETED = 'SENSOR_MODELS_FETCH_COMPLETED';
export const SENSOR_MODELS_FETCH_FAILED = 'SENSOR_MODELS_FETCH_FAILED';
